// extracted by mini-css-extract-plugin
export default {"overFlowMenu":"VLoz8DX---styles_overFlowMenu__oLySf","icon":"VLoz8DX---styles_icon__S49BJ"};